import { createRoutine } from 'redux-saga-routines';

import { CommunitySubscriptionInfo } from 'types';

export type GetAllSubscriptionsPayload = {
  force?: boolean;
  silent?: boolean;
};

export const getAllSubscriptions = createRoutine('REQUEST_ALL_SUBSCRIPTIONS', {
  trigger: (payload: GetAllSubscriptionsPayload) => payload,
});

export const getSubscriptionPlanId = createRoutine(
  'REQUEST_SUBSCRIPTION_PLAN_ID',
);

export const clearSubscriptionPlanId = createRoutine(
  'CLEAR_SUBSCRIPTION_PLAN_ID',
);

export const getCurrentUserSubscription = createRoutine(
  'REQUEST_CURRENT_USER_SUBSCRIPTION',
);

export const getBillingInvoices = createRoutine('REQUEST_BILLING_INVOICES');

export const setSubscription = createRoutine('SET_SUBSCRIPTION', {
  trigger: (payload: {
    productId: string;
    subscriptionId: string;
    pricing: string;
  }) => payload,
});

export const paymentApproved = createRoutine('PAYMENT_APPROVED', {
  trigger: (payload: {
    subscription: { get: () => Promise<unknown> };
    planName: string;
    value: number;
    currency: string;
    billingInterval: 'yearly' | 'monthly';
    memberCount: number;
  }) => payload,
});

export const switchSubscription = createRoutine('SWITCH_SUBSCRIPTION', {
  trigger: (payload: { id: string; frequency: string }) => payload,
});

export const startTrial = createRoutine('START_TRIAL');

export const activateSubscription = createRoutine('ACTIVATE_SUBSCRIPTION', {
  trigger: (payload: string) => payload,
});

export const cancelSubscription = createRoutine('CANCEL_SUBSCRIPTION', {
  trigger: (payload: { subscriptionId: string; reason: string[] }) => payload,
});

export const hasAdblocker = createRoutine('HAS_ADBLOCKER');

/** Merge partial usage fields into the cached subscription without refetching. */
export const adjustSubscriptionInfo = createRoutine(
  'ADJUST_SUBSCRIPTION_INFO',
  {
    trigger: (payload: Partial<CommunitySubscriptionInfo>) => payload,
  },
);
